import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["style", "onLoad", "onError", "alt"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
export const Img = React.forwardRef(function Img(props, ref) {
  const {
      style,
      onLoad,
      onError,
      alt
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  return React.createElement("img", _extends({}, otherProps, {
    alt: alt,
    onLoad: onLoad,
    onError: onError,
    ref: ref,
    style: _objectSpread({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center"
    }, style)
  }));
});
Img.propTypes = process.env.NODE_ENV !== "production" ? {
  style: PropTypes.object,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  alt: PropTypes.string
} : {};
Img.defaultProps = {
  style: {},
  onError: null,
  onLoad: null,
  alt: ''
};